import userLocalStorage from '@/storage/user-local-storage';
import {computed, defineComponent, onMounted, ref, watch} from 'vue';
import {CoordinateSystem, DownloadUrl} from "@/api/klip-api.proxy";

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlMaprequestDownload',
    props: {
        downloadUrls: {
            type: Array as () => Array<DownloadUrl>,
            required: false,
            default: () => {}
        },
    },
    setup(props) {

        const downloadPreferenceLocalStorageKey: string = 'download_preference';

        const downloadFiletype = ref<string>(`GeoJson_${CoordinateSystem[CoordinateSystem.Lambert72]}`);

        const downloadFileUri = computed<string>(() => {
            if(props.downloadUrls && downloadFiletype.value) {
                const fileType = downloadFiletype.value.split('_')[0];
                const coordinateSystem = downloadFiletype.value.split('_')[1];
                return props.downloadUrls.find((downloadUrl: DownloadUrl) => downloadUrl.fileFormat === fileType && downloadUrl.coordinateSystem === CoordinateSystem[coordinateSystem as keyof typeof CoordinateSystem])?.url;
            }
            return null;
        });

        const parseValue = (DownloadUrl: DownloadUrl) => {
            return `${DownloadUrl.fileFormat}_${CoordinateSystem[DownloadUrl.coordinateSystem]}`;
        };

        const downloadFiletypeChanged = (newDownloadFiletype: string) => {
            userLocalStorage.setItem(downloadPreferenceLocalStorageKey, newDownloadFiletype);
        }

        const lambert72DownloadUrls = computed<Array<DownloadUrl>>(() => {
            return props.downloadUrls.filter((downloadUrl: DownloadUrl) => downloadUrl.coordinateSystem === CoordinateSystem.Lambert72);
        });

        const lambert2008DownloadUrls = computed<Array<DownloadUrl>>(() => {
            return props.downloadUrls.filter((downloadUrl: DownloadUrl) => downloadUrl.coordinateSystem === CoordinateSystem.Lambert2008);
        });

        watch(
            downloadFiletype,
            (newValue) => {
                downloadFiletypeChanged(newValue);
            },
            { immediate: false });

        onMounted(() => {
            let preferenceFromLocalStorage = userLocalStorage.getItem(downloadPreferenceLocalStorageKey) || `GeoJson_${CoordinateSystem[CoordinateSystem.Lambert72]}`;
            if(!preferenceFromLocalStorage.includes('_')){
                //this is possible with values before the Lambert2008 migration from the localstorage, so we need to add the coordinate system
                preferenceFromLocalStorage = `${preferenceFromLocalStorage}_${CoordinateSystem[CoordinateSystem.Lambert72]}`;
            }
            downloadFiletype.value = preferenceFromLocalStorage;
        });

        return {
            downloadFiletype,
            downloadFileUri,
            lambert72DownloadUrls,
            lambert2008DownloadUrls,
            parseValue
        }
    }
})
